import React, { useMemo } from 'react';
import { DEFAULT_ATTRIBUTES } from '../../../../../utils/constants/meteo.js';
import { BatteryIcon } from '../../../../common/Meteo/BatteryIcon';
import { SignalIcon } from '../../../../common/Meteo/SignalIcon';
import { RawHtml } from '../../../../common';
import { isUndefined } from 'lodash';

export function AttributeIconRenderer({ attribute }) {
  const value = useMemo(
    () => attribute.sensor_value?.value,
    [attribute.sensor_value?.value],
  );
  const isValuePresent = useMemo(
    () => !isUndefined(attribute.sensor_value?.value),
    [attribute.sensor_value?.value],
  );

  return (
    <>
      {attribute.key === DEFAULT_ATTRIBUTES.BATTERY ? (
        <BatteryIcon percentage={isValuePresent ? value : 100} />
      ) : attribute.key === DEFAULT_ATTRIBUTES.LINK_QUALITY ? (
        <SignalIcon
          percentage={isValuePresent ? (value / 256) * 100 : 100}
          variant="blue-and-yellow"
        />
      ) : (
        <i className={attribute.icon}></i>
      )}
    </>
  );
}
